import * as storage from './storage'

export const getItem = (key: string) =>
	storage.getItem(key, window.localStorage)

export function removeItem(key: string) {
	storage.removeItem(key, window.localStorage)
}

export function setItem(key: string, value: unknown) {
	storage.setItem(key, value, window.localStorage)
}
